import React, { useContext } from 'react'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '@clientbase/clientbase-library'
import { Box, Typography } from '@mui/material'
import moment from 'moment'

import { DetailCompanyRow } from 'components/DetailCompany'

import { NegativateStatus } from 'utils/enums'

import { theme } from 'styles/theme'

import { NegativationContext } from '../../context'
import { renderTitle } from '../utils'
import { S } from './'

const NegativationDetail: React.FC = () => {
  const { negativation } = useContext(NegativationContext)
  return (
    <Accordion defaultExpanded>
      <AccordionSummary aria-controls="payerDetails-content" id="payerDetails">
        {renderTitle('Detalhes da negativação', 'thumbDownAlt')}
      </AccordionSummary>
      <AccordionDetails>
        <div>
          {/* SC-10999: de qual empresa é a negativação, na visão multi-empresas */}
          <DetailCompanyRow
            recordUuid={negativation?.uuid}
            margin="10px 0px 10px 0px"
          />
          <Box
            display="flex"
            gap={1.25}
            alignItems="end"
            margin={'10px 0px 10px 0px'}
          >
            {/* TODO: Verificar */}
            <Typography variant="smLight" color={theme.palette.neutral[400]}>
              Data negativação
            </Typography>
            <S.Separator sx={{ marginTop: '4px' }} />
            <Typography variant="smBold" display="flex" alignItems="center">
              {moment(negativation?.created_at).format('DD/MM/yyyy')}
            </Typography>
          </Box>
          <Box
            display="flex"
            gap={1.25}
            alignItems="end"
            margin={'10px 0px 10px 0px'}
          >
            {/* TODO: Verificar */}
            <Typography variant="smLight" color={theme.palette.neutral[400]}>
              Etapa do processo
            </Typography>
            <S.Separator sx={{ marginTop: '4px' }} />
            <Typography variant="smBold" display="flex" alignItems="center">
              {NegativateStatus[negativation?.status]}
            </Typography>
          </Box>
          {negativation?.status_detail && (
            <Box
              display="flex"
              gap={1.25}
              alignItems="end"
              margin={'10px 0px 10px 0px'}
            >
              <Typography variant="smLight" color={theme.palette.neutral[400]}>
                Detalhes do status
              </Typography>
              <S.Separator sx={{ marginTop: '4px' }} />
              <Typography variant="smBold" display="flex" alignItems="center">
                {negativation?.status_detail}
              </Typography>
            </Box>
          )}
          {/* TODO: Verificar termo aditivo */}
          {/* <Box
            display="flex"
            gap={1.25}
            alignItems="end"
            margin={'10px 0px 10px 0px'}
          >
            <Typography variant="smLight" color="#777777">
              Termo aditivo:
            </Typography>
            <S.Separator sx={{ marginTop: '4px' }} />
            <Typography
              variant="smBold"
              display="flex"
              alignItems="center"
              sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            >
              Visualizar termo
            </Typography>
          </Box> */}
        </div>
      </AccordionDetails>
    </Accordion>
  )
}

export default NegativationDetail
